/*
  HO-CUSTOM: footer restock signup (snippets/form-email-signup.liquid): email-first form with an SMS toggle that
  posts straight to Klaviyo (company Y7minv; email list X3aXSp, SMS list RDTjkW, same consent as before).
  HO-PERF: this was an inline <script> per signup block, re-sent with every page's HTML; it is now one cached,
  deferred file that binds every form[id^="ho-sms-signup-"] (the block id is the form id's suffix). The
  dataset.hoBound guard keeps each form bound once, also when the theme editor re-renders the footer.
*/
(function () {
  function bind(form) {
    if (!form || form.dataset.hoBound) return;
    form.dataset.hoBound = '1';

    var COMPANY = 'Y7minv';
    var LIST_SMS = 'RDTjkW';
    var LIST_EMAIL = 'X3aXSp';

    var emailInput = form.querySelector('.ho-email-input');
    var phoneInput = form.querySelector('.ho-sms-phone');
    var headingWord = document.getElementById('ho-channel-word-' + form.id.slice(14)); // id = 'ho-sms-signup-' + block.id
    var channelToggle = form.querySelector('.ho-channel-toggle');
    var msg = form.querySelector('.ho-sms-msg');
    var btn = form.querySelector('input[type=submit]');
    var origBtn;

    function all(sel) { return form.querySelectorAll(sel); }

    function showMsg(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.style.color = ok ? '#2F4E3F' : '#b00020';
      msg.removeAttribute('hidden');
    }
    function clearMsg() { if (msg) { msg.setAttribute('hidden', ''); msg.textContent = ''; } }
    function busyBtn() { origBtn = btn.value; btn.value = 'Sending...'; btn.disabled = true; }
    function resetBtn() { if (origBtn) btn.value = origBtn; btn.disabled = false; }

    // Per-consent "Show disclaimer" toggles.
    Array.prototype.forEach.call(all('.ho-disc-toggle'), function (tog) {
      tog.addEventListener('click', function () {
        var disc = document.getElementById(tog.getAttribute('aria-controls'));
        if (!disc) return;
        var open = disc.hasAttribute('hidden');
        if (open) { disc.removeAttribute('hidden'); tog.innerHTML = 'Hide&nbsp;disclaimer'; }
        else { disc.setAttribute('hidden', ''); tog.innerHTML = 'Show&nbsp;disclaimer'; }
        tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    function setMode(mode) {
      var email = mode === 'email';
      form.setAttribute('data-mode', mode);

      if (email) {
        phoneInput.setAttribute('hidden', ''); phoneInput.disabled = true;
        emailInput.removeAttribute('hidden'); emailInput.disabled = false;
      } else {
        emailInput.setAttribute('hidden', ''); emailInput.disabled = true;
        phoneInput.removeAttribute('hidden'); phoneInput.disabled = false;
      }

      if (headingWord) headingWord.textContent = email ? 'email' : 'text';
      if (channelToggle) channelToggle.textContent = email ? 'Prefer a text instead?' : 'Prefer email instead?';

      Array.prototype.forEach.call(all('.ho-consent'), function (c) {
        if (c.getAttribute('data-mode') === mode) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
      Array.prototype.forEach.call(all('.ho-disclaimer'), function (d) { d.setAttribute('hidden', ''); });
      Array.prototype.forEach.call(all('.ho-disc-toggle'), function (t) { t.setAttribute('aria-expanded', 'false'); t.innerHTML = 'Show&nbsp;disclaimer'; });

      clearMsg();
      (email ? emailInput : phoneInput).focus();
    }

    if (channelToggle) {
      channelToggle.addEventListener('click', function () {
        setMode(form.getAttribute('data-mode') === 'email' ? 'sms' : 'email');
      });
    }

    function formatAU(raw) {
      var s = (raw || '').trim();
      if (s.charAt(0) === '+') return '+' + s.slice(1).replace(/[^0-9]/g, '');
      var d = s.replace(/[^0-9]/g, '');
      if (d.indexOf('0') === 0) d = d.slice(1);
      if (d.indexOf('61') === 0) return '+' + d;
      return '+61' + d;
    }

    function subscribe(payload, onOk) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202) { onOk(); }
        else { showMsg('Hmm, that did not work - please check your details and try again.', false); resetBtn(); }
      }).catch(function () {
        showMsg('Network error - please try again.', false); resetBtn();
      });
    }

    function finishSuccess(text) {
      var wrap = form.querySelector('.form__input-wrapper');
      if (wrap) wrap.style.display = 'none';
      Array.prototype.forEach.call(all('.ho-consent'), function (c) { c.style.display = 'none'; });
      Array.prototype.forEach.call(all('.ho-disclaimer'), function (d) { d.setAttribute('hidden', ''); });
      if (channelToggle) channelToggle.style.display = 'none';
      showMsg(text, true);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mode = form.getAttribute('data-mode') === 'email' ? 'email' : 'sms';

      if (mode === 'email') {
        var em = (emailInput.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { showMsg('Please enter a valid email address.', false); return; }
        busyBtn();
        subscribe({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer restock signup (email)',
              profile: { data: { type: 'profile', attributes: {
                email: em,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: LIST_EMAIL } } }
          }
        }, function () {
          finishSuccess("You're now signed up for Hydro Oasis updates. We'll email you when new stock lands.");
          try { if (window._learnq) window._learnq.push(['track', 'Footer Email Signup']); } catch (err) {}
        });
      } else {
        var phone = formatAU(phoneInput.value);
        var valid = phone.charAt(0) === '+' && /^[0-9]+$/.test(phone.slice(1)) && phone.length >= 9 && phone.length <= 16;
        if (!valid) { showMsg('Please enter a valid mobile number.', false); return; }
        busyBtn();
        subscribe({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer restock signup (SMS)',
              profile: { data: { type: 'profile', attributes: {
                phone_number: phone,
                subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: LIST_SMS } } }
          }
        }, function () {
          finishSuccess("You're in! We'll text you the moment rare stock lands.");
          try { if (window._learnq) window._learnq.push(['track', 'Footer SMS Signup']); } catch (err) {}
        });
      }
    });
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form[id^="ho-sms-signup-"]'), bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: a re-rendered footer section arrives as new HTML without the old inline script.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
